// Components
import Breadcrumbs from '@/components/ui/Breadcrumbs'

import ComponentsHistoryTable from '@/components/components/ComponentsHistoryTable'

export default function ComponentHistoryPage() {
    return (
        <div>
            <Breadcrumbs
                breadcrumbs={[
                    {
                        label: 'Mouvements de stock',
                    },
                ]}
            />

            <ComponentsHistoryTable />
        </div>
    )
}
